
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexsUjD1Oz1dZLIltHjE5srdMs7iyO63R_u2uk31qTHWkAMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/index.vue?macro=true";
import { default as astucesT_0hwn6OtGMvjjzwlhjgTP7_45n5Eg7GqJ3kIvZI4qzKoMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/astuces.vue?macro=true";
import { default as landingaGn1fScwsRzpB2UNDpsnAHfs8JqpQmrZl7IdYSq4pO4Meta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/landing.vue?macro=true";
import { default as astrobotd_45MGteRaSAOrEQ3iIqW_45PsTXAq3hr7qiuBr_0EkfKdEMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/astrobot.vue?macro=true";
import { default as avantagesSjemBpjS9ZJoJU2rU8yeNrOq4wfcoKGptCPbqBaxT5wMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/avantages.vue?macro=true";
import { default as recherchetbs9ukPim_2JsLyBEJWjPfQJonnPS6cps_YKeX8XZp0Meta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/recherche.vue?macro=true";
import { default as challengesjNRP1f7C76OXbyE2t9sjUasqo5e9r7xOLLBd2MRsicgMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/challenges.vue?macro=true";
import { default as mon_45profiliND8jzQ6TqRkGKOquQYpz_45WaEPYtTe12hcBr0Vo86sIMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/mon-profil.vue?macro=true";
import { default as avis_45mediasOEvvImQb823OY5z4SI3uU_45sEpler2UDh2XWi4BpOlM4Meta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/avis-medias.vue?macro=true";
import { default as inscription_uohSYqVCPS_45nucR0aYoI9NxbwvYxJxXyUP0P_45SwVfAMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/inscription.vue?macro=true";
import { default as avis_45joueursL99YaxXRYc3jR27TSRQkDD9u8oq2oTSgxUlL53MTmicMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/avis-joueurs.vue?macro=true";
import { default as indexZX_45PO1_1tXSKvJMuVA_45BrMzVGA3_qbPlrENggEI0XJsMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/offres/index.vue?macro=true";
import { default as indexzkZjFtNvVhw7DV876ubCEYKoZtvK07ekZIDizEf2ypkMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/wapers/index.vue?macro=true";
import { default as indexEONShZHL_2I8_45772P6Zbe63ojodfiAJhdAOCgVidfrQMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/concours/index.vue?macro=true";
import { default as _91pageName_936z_thT3Auke7Upn08UP4FMrY5dfqrSVZishVv70B5MEMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/page/[pageName].vue?macro=true";
import { default as indexwksPKi79oKfA_45Xi_0iHHUxKc1_45usayUmTcPBcCUk2BcMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/index.vue?macro=true";
import { default as _91nickname_93_C_dc_eU1DLlf8gfzWdlg37wGByjw_bwrDUyUOFIyFoMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/wapers/[nickname].vue?macro=true";
import { default as _91offerName_93ScHLxrNGtPfyvM8r7HGdo_457TkDUL7BRPD5ReXEGPtmIMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/offres/[offerName].vue?macro=true";
import { default as le_45feed_45des_45playersDZ0ns5Eg46DCnbQPJR2nJ4AnQ2_3j11_45OfibbotqRgIMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/le-feed-des-players.vue?macro=true";
import { default as actualites_45communautest_45CKLtuMcDjhlqzud_xCRdXMq7Xh8EsmwJX498aWKkEMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-communautes.vue?macro=true";
import { default as _91contestName_93NwYBOv2OKwnnV2SSRVxclCdoLkEpkAheLi6_YgiWwoUMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/concours/[contestName].vue?macro=true";
import { default as _91tournamentName_93GTs0k8kf_iVKr4nRerENRq_79pyMiFLqyh1MswBrno4Meta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/tournoi/[tournamentName].vue?macro=true";
import { default as _91challengeName_93hrXNSlxN_ITcvbSOGKnt7jfRUU9JwfGZblUOn5ISvNwMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/challenge/[challengeName].vue?macro=true";
import { default as _91contestName_93rZExefFNoHX7wZJC_45KglWp_45IgM9rObNlZiDykPmLV5gMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/jeu-concours/[contestName].vue?macro=true";
import { default as _91typeName_936eTEn04omotqfX6cX0G583rJALRL_d5XgLrzdwBBDVEMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/type/[typeName].vue?macro=true";
import { default as indexkodM8V6M0_Wg8lZTTFJpkUHDlrXHSADFRuXtE80J_hEMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-playstation/index.vue?macro=true";
import { default as _91title_934T0WrXCZF_8tDkMgQWMi_45tnJ3Blv6NH_45w1zYag3QZJAMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-playstation/[title].vue?macro=true";
import { default as _91genderName_93ljZ5m8graBPO2hQE62mN5GE_452PVX9o42EOkoDjmF1JEMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/genre/[genderName].vue?macro=true";
import { default as indexSKf8I0xY2pbsKdJa9AGF5niRpdvFjJXMjf2D5GjFaTYMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/index.vue?macro=true";
import { default as _91contestName_93PWNSEdtVZrcgutpBLyunkEO2QO9BERz4bKb0PSYdOOkMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/concours-classement/[contestName].vue?macro=true";
import { default as index2eBPKB2XmIzMzkO_45nv2513Wa3AChw75vlZVUAJKFYIwMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/wapers/index.vue?macro=true";
import { default as indexMY6uYxRMfi3R_45seBSiS8v0cndptShTsm6rhi5L2dD8IMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/astuces/index.vue?macro=true";
import { default as concours_45stellar_45blade4CoM_Y0DWxrTxz1ShpO6wUuS6VQBkEtnGbvki2DNpIUMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-playstation/concours-stellar-blade.vue?macro=true";
import { default as indexx0R_45qjZWxSw7tXaObZyVodn7O3B0D5pSNSQJdeBYCfwMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/index.vue?macro=true";
import { default as indexplsx47xwAuH_459rAzwzEFaqcyN3biC_1UjDGLIC3Cw2EMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/index.vue?macro=true";
import { default as _91postTitle_93FnVoQC9J21a5n8whxpi1hKUvJFXkpI3psAVjsv5_qngMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/[postTitle].vue?macro=true";
import { default as indexta2xOC_1f7y36qUVf4ixnbZKZ01vqVu9IBaBa9AP15QMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/index.vue?macro=true";
import { default as indexxfhzq3J03Y45jdoV6R46S19qoFr4JwylCqWiGCgOz8cMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/index.vue?macro=true";
import { default as indexAyteMV2m9_45OcTiY170_45pRxgG9gQjgX6bw879_45qojWa8Meta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/index.vue?macro=true";
import { default as _91postTitle_93B62tF_CkxWGn7gikenH0jhn88suPxc9v3SGVTqJJiwIMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/detail/[postTitle].vue?macro=true";
import { default as _91postTitle_936FhjjsLVXyGZXptyNXq8Cz9kV0mJQrF6THgoucstejIMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/[postTitle].vue?macro=true";
import { default as _91postTitle_937EBZ_nR_45wdJRLaflk8QxwQwHbRzgLU9CmI_A1IasTYgMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/[postTitle].vue?macro=true";
import { default as indexgUDGgmIpBCc_45FyfAoq5IGIH0JdMbVbu5qTm7x4j2_457AMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/index.vue?macro=true";
import { default as _91postTitle_93fmQwhKuJc65Ngxs6W3VTfEFw7t7iPG2pplutNFLsj5UMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/[postTitle].vue?macro=true";
import { default as component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_koMeta } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.14.9_@vue+compiler-sfc@3.5.44_cac@6.7._4nw34muufof73viqpe4o44xswm/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_ko } from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.14.9_@vue+compiler-sfc@3.5.44_cac@6.7._4nw34muufof73viqpe4o44xswm/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/index.vue")
  },
  {
    name: "astuces",
    path: "/astuces",
    meta: astucesT_0hwn6OtGMvjjzwlhjgTP7_45n5Eg7GqJ3kIvZI4qzKoMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/astuces.vue")
  },
  {
    name: "landing",
    path: "/landing",
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/landing.vue")
  },
  {
    name: "astrobot",
    path: "/astrobot",
    meta: astrobotd_45MGteRaSAOrEQ3iIqW_45PsTXAq3hr7qiuBr_0EkfKdEMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/astrobot.vue")
  },
  {
    name: "avantages",
    path: "/avantages",
    meta: avantagesSjemBpjS9ZJoJU2rU8yeNrOq4wfcoKGptCPbqBaxT5wMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/avantages.vue")
  },
  {
    name: "recherche",
    path: "/recherche",
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/recherche.vue")
  },
  {
    name: "challenges",
    path: "/challenges",
    meta: challengesjNRP1f7C76OXbyE2t9sjUasqo5e9r7xOLLBd2MRsicgMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/challenges.vue")
  },
  {
    name: "mon-profil",
    path: "/mon-profil",
    meta: {"middleware":["temp-auth"]},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/mon-profil.vue")
  },
  {
    name: "avis-medias",
    path: "/avis-medias",
    meta: avis_45mediasOEvvImQb823OY5z4SI3uU_45sEpler2UDh2XWi4BpOlM4Meta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/avis-medias.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/inscription.vue")
  },
  {
    name: "avis-joueurs",
    path: "/avis-joueurs",
    meta: avis_45joueursL99YaxXRYc3jR27TSRQkDD9u8oq2oTSgxUlL53MTmicMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/avis-joueurs.vue")
  },
  {
    name: "offres",
    path: "/offres",
    meta: indexZX_45PO1_1tXSKvJMuVA_45BrMzVGA3_qbPlrENggEI0XJsMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/offres/index.vue")
  },
  {
    name: "wapers",
    path: "/wapers",
    meta: indexzkZjFtNvVhw7DV876ubCEYKoZtvK07ekZIDizEf2ypkMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/wapers/index.vue")
  },
  {
    name: "concours",
    path: "/concours",
    meta: indexEONShZHL_2I8_45772P6Zbe63ojodfiAJhdAOCgVidfrQMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/concours/index.vue")
  },
  {
    name: "page-pageName",
    path: "/page/:pageName()",
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/page/[pageName].vue")
  },
  {
    name: "communautes",
    path: "/communautes",
    meta: indexwksPKi79oKfA_45Xi_0iHHUxKc1_45usayUmTcPBcCUk2BcMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/index.vue")
  },
  {
    name: "wapers-nickname",
    path: "/wapers/:nickname()",
    meta: _91nickname_93_C_dc_eU1DLlf8gfzWdlg37wGByjw_bwrDUyUOFIyFoMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/wapers/[nickname].vue")
  },
  {
    name: "offres-offerName",
    path: "/offres/:offerName()",
    meta: _91offerName_93ScHLxrNGtPfyvM8r7HGdo_457TkDUL7BRPD5ReXEGPtmIMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/offres/[offerName].vue")
  },
  {
    name: "le-feed-des-players",
    path: "/le-feed-des-players",
    meta: le_45feed_45des_45playersDZ0ns5Eg46DCnbQPJR2nJ4AnQ2_3j11_45OfibbotqRgIMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/le-feed-des-players.vue")
  },
  {
    name: "actualites-communautes",
    path: "/actualites-communautes",
    meta: actualites_45communautest_45CKLtuMcDjhlqzud_xCRdXMq7Xh8EsmwJX498aWKkEMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-communautes.vue")
  },
  {
    name: "concours-contestName",
    path: "/concours/:contestName()",
    meta: _91contestName_93NwYBOv2OKwnnV2SSRVxclCdoLkEpkAheLi6_YgiWwoUMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/concours/[contestName].vue")
  },
  {
    name: "tournoi-tournamentName",
    path: "/tournoi/:tournamentName()",
    meta: _91tournamentName_93GTs0k8kf_iVKr4nRerENRq_79pyMiFLqyh1MswBrno4Meta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/tournoi/[tournamentName].vue")
  },
  {
    name: "challenge-challengeName",
    path: "/challenge/:challengeName()",
    meta: _91challengeName_93hrXNSlxN_ITcvbSOGKnt7jfRUU9JwfGZblUOn5ISvNwMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/challenge/[challengeName].vue")
  },
  {
    name: "jeu-concours-contestName",
    path: "/jeu-concours/:contestName()",
    meta: _91contestName_93rZExefFNoHX7wZJC_45KglWp_45IgM9rObNlZiDykPmLV5gMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/jeu-concours/[contestName].vue")
  },
  {
    name: "communautes-type-typeName",
    path: "/communautes/type/:typeName()",
    meta: _91typeName_936eTEn04omotqfX6cX0G583rJALRL_d5XgLrzdwBBDVEMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/type/[typeName].vue")
  },
  {
    name: "actualites-playstation",
    path: "/actualites-playstation",
    meta: indexkodM8V6M0_Wg8lZTTFJpkUHDlrXHSADFRuXtE80J_hEMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-playstation/index.vue")
  },
  {
    name: "actualites-playstation-title",
    path: "/actualites-playstation/:title()",
    meta: _91title_934T0WrXCZF_8tDkMgQWMi_45tnJ3Blv6NH_45w1zYag3QZJAMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-playstation/[title].vue")
  },
  {
    name: "communautes-genre-genderName",
    path: "/communautes/genre/:genderName()",
    meta: _91genderName_93ljZ5m8graBPO2hQE62mN5GE_452PVX9o42EOkoDjmF1JEMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/genre/[genderName].vue")
  },
  {
    name: "communautes-communityName",
    path: "/communautes/:communityName()",
    meta: indexSKf8I0xY2pbsKdJa9AGF5niRpdvFjJXMjf2D5GjFaTYMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/index.vue")
  },
  {
    name: "concours-classement-contestName",
    path: "/concours-classement/:contestName()",
    meta: _91contestName_93PWNSEdtVZrcgutpBLyunkEO2QO9BERz4bKb0PSYdOOkMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/concours-classement/[contestName].vue")
  },
  {
    name: "communautes-communityName-wapers",
    path: "/communautes/:communityName()/wapers",
    meta: index2eBPKB2XmIzMzkO_45nv2513Wa3AChw75vlZVUAJKFYIwMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/wapers/index.vue")
  },
  {
    name: "communautes-communityName-astuces",
    path: "/communautes/:communityName()/astuces",
    meta: indexMY6uYxRMfi3R_45seBSiS8v0cndptShTsm6rhi5L2dD8IMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/astuces/index.vue")
  },
  {
    name: "actualites-playstation-concours-stellar-blade",
    path: "/actualites-playstation/concours-stellar-blade",
    meta: concours_45stellar_45blade4CoM_Y0DWxrTxz1ShpO6wUuS6VQBkEtnGbvki2DNpIUMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/actualites-playstation/concours-stellar-blade.vue")
  },
  {
    name: "communautes-communityName-avis-medias",
    path: "/communautes/:communityName()/avis-medias",
    meta: indexx0R_45qjZWxSw7tXaObZyVodn7O3B0D5pSNSQJdeBYCfwMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/index.vue")
  },
  {
    name: "communautes-communityName-avis-joueurs",
    path: "/communautes/:communityName()/avis-joueurs",
    meta: indexplsx47xwAuH_459rAzwzEFaqcyN3biC_1UjDGLIC3Cw2EMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/index.vue")
  },
  {
    name: "communautes-communityName-avis-medias-postTitle",
    path: "/communautes/:communityName()/avis-medias/:postTitle()",
    meta: _91postTitle_93FnVoQC9J21a5n8whxpi1hKUvJFXkpI3psAVjsv5_qngMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-medias/[postTitle].vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players",
    path: "/communautes/:communityName()/le-feed-des-players",
    meta: indexta2xOC_1f7y36qUVf4ixnbZKZ01vqVu9IBaBa9AP15QMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/index.vue")
  },
  {
    name: "communautes-communityName-actualites-communaute",
    path: "/communautes/:communityName()/actualites-communaute",
    meta: indexxfhzq3J03Y45jdoV6R46S19qoFr4JwylCqWiGCgOz8cMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/index.vue")
  },
  {
    name: "communautes-communityName-astuces-subCategoryName",
    path: "/communautes/:communityName()/astuces/:subCategoryName()",
    meta: indexAyteMV2m9_45OcTiY170_45pRxgG9gQjgX6bw879_45qojWa8Meta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/index.vue")
  },
  {
    name: "communautes-communityName-avis-joueurs-detail-postTitle",
    path: "/communautes/:communityName()/avis-joueurs/detail/:postTitle()",
    meta: _91postTitle_93B62tF_CkxWGn7gikenH0jhn88suPxc9v3SGVTqJJiwIMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/avis-joueurs/detail/[postTitle].vue")
  },
  {
    name: "communautes-communityName-actualites-communaute-postTitle",
    path: "/communautes/:communityName()/actualites-communaute/:postTitle()",
    meta: _91postTitle_936FhjjsLVXyGZXptyNXq8Cz9kV0mJQrF6THgoucstejIMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/actualites-communaute/[postTitle].vue")
  },
  {
    name: "communautes-communityName-astuces-subCategoryName-postTitle",
    path: "/communautes/:communityName()/astuces/:subCategoryName()/:postTitle()",
    meta: _91postTitle_937EBZ_nR_45wdJRLaflk8QxwQwHbRzgLU9CmI_A1IasTYgMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/astuces/[subCategoryName]/[postTitle].vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players-subCategoryName",
    path: "/communautes/:communityName()/le-feed-des-players/:subCategoryName()",
    meta: indexgUDGgmIpBCc_45FyfAoq5IGIH0JdMbVbu5qTm7x4j2_457AMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/index.vue")
  },
  {
    name: "communautes-communityName-le-feed-des-players-subCategoryName-postTitle",
    path: "/communautes/:communityName()/le-feed-des-players/:subCategoryName()/:postTitle()",
    meta: _91postTitle_93fmQwhKuJc65Ngxs6W3VTfEFw7t7iPG2pplutNFLsj5UMeta || {},
    component: () => import("/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/pages/communautes/[communityName]/le-feed-des-players/[subCategoryName]/[postTitle].vue")
  },
  {
    name: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_koMeta?.name,
    path: "/le-coin-des-wapers",
    component: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_ko
  },
  {
    name: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_koMeta?.name,
    path: "/0-sitemap.xml",
    component: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_ko
  },
  {
    name: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_koMeta?.name,
    path: "/1-sitemap.xml",
    component: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_ko
  },
  {
    name: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_koMeta?.name,
    path: "/2-sitemap.xml",
    component: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_ko
  },
  {
    name: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_koMeta?.name,
    path: "/3-sitemap.xml",
    component: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_ko
  },
  {
    name: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_koMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubQmi_457AEPuuJc8VydNbK1dqWb7uWY_45b0HlWn7tRed_ko
  }
]